function buildFilter(filters, saved) {
    const newFilters = {};
    let i = 0;
    Object.keys(filters).forEach((index) => {
        const currentFilter = filters[index];
        Object.keys(saved).forEach((ind) => {
            const newFilter = `${currentFilter}${saved[ind]}`;
            newFilters[i] = newFilter;
            i++;
        });
    });
    return newFilters;
}

function toggleSpecs(e) {
    e.preventDefault();

    const container = document.querySelector('.buy-child-list');
    const clickedSpec = e.target;
    const value = clickedSpec.dataset.value;

    // give better vairbale names
    let type = "";
    const classes = {};
    let k = 0;
    let max = 0;

    clickedSpec.classList.toggle("active");

    const allClasses = document.querySelectorAll(".specific");
    allClasses.forEach((specific) => {
        const len = specific.querySelectorAll(".item_specs.active").length;
        if (len > max) {
            max = len;
            type = specific.querySelector("input._itmspec_val").getAttribute("ref");
        }
    });

    const specificClasses = document.querySelectorAll(
        `.specific.specific_${type} .item_specs.active`
    );
    specificClasses.forEach((itemSpec) => {
        const spValue = itemSpec.dataset.value;
        const itemSpecVal = `.specs_${spValue}`;
        classes[k] = itemSpecVal;
        k++;
    });

    const customClass = {};
    let j = 0;
    allClasses.forEach((specific) => {
        const sp = specific.querySelector("input._itmspec_val") ? specific.querySelector("input._itmspec_val").getAttribute("ref") : "";
        if (
            specific.querySelectorAll(".item_specs.active").length > 0 &&
            !specific.classList.contains(`specific_${type}`)
        ) {
            customClass[sp] = {};
            const specificClasses = specific.querySelectorAll(".item_specs.active");
            specificClasses.forEach((itemSpec) => {
                var value = itemSpec.dataset.value;
                const itemSpecVal = `.specs_${value}`;
                customClass[sp][j] = itemSpecVal;
                j++;
            });
        }
    });

    let filters = {};
    let n = 0;
    if (Object.keys(classes).length > 0) {
        filters = classes;
        if (Object.keys(customClass).length > 0) {
            Object.keys(customClass).forEach((ind) => {
                filters = buildFilter(filters, customClass[ind]);
            });
        }
    }

    const total = document.querySelectorAll(
        ".buy-child-list .child-product"
    ).length;

    if (k > 0) {
        container.style.height = "auto";
        document
            .querySelectorAll(".buy-child-list .child-product")
            .forEach((childProduct) => {
                childProduct.style.display = "none";
                childProduct.classList.remove("active");
            });

        let applied = 0;
        Object.keys(filters).forEach((index) => {
            const spec = filters[index];
            const matchingChildProducts = document.querySelectorAll(
                `.buy-child-list .child-product${spec}`
            );
            if (matchingChildProducts.length > 0) {
                matchingChildProducts.forEach((childProduct) => {
                    childProduct.style.display = "grid";
                    childProduct.classList.add("active");
                });
            }
        });
    } else {
        document
            .querySelectorAll(".buy-child-list .child-product")
            .forEach((childProduct) => {
                childProduct.style.display = "grid";
            });
    }
    const activeChildProducts = document.querySelectorAll(".buy-child-list .child-product.active");

    // Reset data-last attributes
    activeChildProducts.forEach(product => {
        const existingLuxButtons = product.querySelector('.variant-info-container .lux-buttons > * .popover.lux');
        if (existingLuxButtons) {
            existingLuxButtons.removeAttribute('data-last');
        }
    });

    // Set data-last to the .popover.lux of the last active product or the only active product
    if (activeChildProducts.length > 0) {
        const lastActiveProduct = activeChildProducts[activeChildProducts.length - 1];
        const luxButtons = lastActiveProduct.querySelector('.variant-info-container .lux-buttons > * .popover.lux');
        if (luxButtons) {
            luxButtons.setAttribute('data-last', 'true');
        }
    }
}

function sortChildProductsByDataValue() {
    const container = document.querySelector('.buy-child-list');
    const products = Array.from(container.querySelectorAll('.child-product'));

    // Only sort if there are more than 1 product
    if (products.length > 1) {
        products.sort((a, b) => {
            const aValue = parseInt(a.getAttribute('data'), 10);
            const bValue = parseInt(b.getAttribute('data'), 10);
            return bValue - aValue; // Descending order
        });

        products.forEach((product, index) => {
            container.appendChild(product);
            product.style.display = 'grid';

            if (index === products.length - 1) {
                const luxButtons = product.querySelector('.variant-info-container .lux-buttons > * .popover.lux');
                if (luxButtons) {
                    luxButtons.setAttribute('data-last', 'true');
                }
            }

            setTimeout(() => product.style.opacity = '1', 50);
        });
    } else {
        setTimeout(() => {
            products[0].style.display = 'grid';
            products[0].style.opacity = '1'
            products[0].querySelector('.variant-info-container .lux-buttons > * .popover.lux').setAttribute('data-last', 'true')
        }, 50)
    }
}

window.addEventListener("DOMContentLoaded", (event) => {
    document.querySelectorAll(".item_specs").forEach((itemSpec) => {
        itemSpec.addEventListener("click", toggleSpecs);
    });

    const viewMoreBtn = document.querySelector('.view-more');
    const container = document.querySelector('.buy-child-list');

    if (viewMoreBtn && container) {
        viewMoreBtn.addEventListener("click", handleViewMoreToggle);
    }

    function handleViewMoreToggle() {
        if (viewMoreBtn.getAttribute('data-expanded') === 'false') {
            expandContainer();
        } else {
            collapseContainer();
        }
    }

    function expandContainer() {
        container.style.maxHeight = '100%';
        container.style.height = '100%';
        viewMoreBtn.setAttribute('data-expanded', 'true');
        viewMoreBtn.textContent = "View Less"; // Optional: Change button text
    }

    function collapseContainer() {
        container.style.maxHeight = '21.5rem'; // Adjust this value as needed
        viewMoreBtn.setAttribute('data-expanded', 'false');
        viewMoreBtn.textContent = "View All"; // Optional: Change button text
    }

    sortChildProductsByDataValue();
})